export default __webpack_public_path__ + "static/media/brand.31cb4fde.png";